
import { Html5Qrcode } from 'html5-qrcode'
let _uid = 0

export default {
  name: 'BarcodeScanner',
  emits: ['scan', 'close'],
  data () {
    return { scanner: null, error: '', diag: '', readerId: 'scanner-' + (++_uid) }
  },
  async mounted () {
    this.runDiagnostics()
    // wait for DOM
    await this.$nextTick()
    await this.startScanner()
  },
  beforeDestroy () {
    this.destroyScanner()
  },
  methods: {
    runDiagnostics () {
      this.diag = [
        '协议: ' + window.location.protocol,
        '安全上下文: ' + (window.isSecureContext ? '是' : '否'),
        'mediaDevices: ' + (navigator.mediaDevices ? '存在' : '不存在'),
        'UA: ' + (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') ? 'Safari' : navigator.userAgent.includes('MicroMessenger') ? '微信' : '其他'),
        '平台: ' + navigator.platform
      ].join(' | ')
    },
    async startScanner () {
      if (!window.isSecureContext && window.location.protocol !== 'https:') {
        this.error = '摄像头需要 HTTPS 环境\n当前: ' + window.location.protocol + '\n诊断: ' + this.diag; return
      }
      if (!navigator.mediaDevices?.getUserMedia) {
        this.error = '当前浏览器不支持摄像头\n诊断: ' + this.diag; return
      }
      await this.destroyScanner()
      try {
        this.scanner = new Html5Qrcode(this.readerId, { verbose: false })
        await this.scanner.start(
          { facingMode: 'environment' },
          {
            fps: 10,
            // 取景框跟随相机画面：宽 94% / 高 72%，贴近边框——框接近实际识别区域，不再误导对位
            qrbox: (vw, vh) => ({ width: Math.floor(vw * 0.94), height: Math.floor(vh * 0.72) }),
            aspectRatio: 1.2
          },
          (decodedText) => { this.$emit('scan', decodedText); this.destroyScanner() },
          () => {}
        )
      } catch (err) {
        const name = err.name || ''; const msg = (err.message || '').toLowerCase()
        if (name === 'NotAllowedError' || msg.includes('notallowed')) this.error = '摄像头权限被拒绝\n请前往 Safari 设置 → 本网站 → 允许摄像头访问\n诊断: ' + this.diag
        else if (name === 'NotReadableError' || msg.includes('notreadable')) this.error = '摄像头被其他应用占用\n请关闭其他使用摄像头的 App\n诊断: ' + this.diag
        else if (name === 'NotFoundError' || msg.includes('notfound')) this.error = '未检测到摄像头\n诊断: ' + this.diag
        else this.error = '摄像头启动失败: ' + (err.message || err) + '\n诊断: ' + this.diag
      }
    },
    async destroyScanner () {
      if (this.scanner) {
        try { await this.scanner.stop() } catch (_) {}
        try { this.scanner.clear() } catch (_) {}
        this.scanner = null
      }
    },
    close () {
      this.destroyScanner()
      this.$emit('close')
    }
  }
}
